import React, {useMemo} from 'react';

const SessionContext = React.createContext();

// Read a cookie by name from document.cookie. Native replacement for the
// react-cookies dependency this used to import — react-cookies wasn't
// resolvable in the portal-mounted Vite build (transitive deps don't
// hop across the file: link from portal/ into editor/), and the actual
// usage was a single line of cookie-read. Stays the same for standalone
// dev where document.cookie has the legacy PHPSESSID set by WP. In
// portal mode no PHPSESSID is set so we fall through to 'DEV' and the
// session is anchored on portal's tenet_session cookie + req.user
// upstream — see §3 of editor README.
function readCookie(name) {
    if (typeof document === 'undefined') return null;
    const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\]^{|}-]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
}

function SessionContextProvider({children}) {
    const sessionId = useMemo(() => readCookie('PHPSESSID') || 'DEV', []);

    return <SessionContext.Provider value={{sessionId}}>{children}</SessionContext.Provider>;
}

const SessionContextConsumer = SessionContext.Consumer;

export {SessionContext, SessionContextConsumer, SessionContextProvider};
